import './PageIntro.css';

interface PageIntroProps {
  /** An icon element (e.g. <PlusIcon size={24} />). Inherits the primary color. Omit for a text-only intro. */
  icon?: React.ReactNode;
  title: string;
  subtitle?: React.ReactNode;
  className?: string;
}

/** Page headline: a primary-colored icon tile on the left, title + subtitle on the right.
 *  Shared by AddFeed / AddNewsletter / MyFeeds for a consistent header treatment. */
const PageIntro: React.FC<PageIntroProps> = ({ icon, title, subtitle, className }) => (
  <div className={`pageIntro${className ? ' ' + className : ''}`}>
    {icon && <span className="pageIntroIcon">{icon}</span>}
    <div className="pageIntroText">
      <h2 className="pageIntroTitle">{title}</h2>
      {subtitle && <p className="pageIntroSubtitle">{subtitle}</p>}
    </div>
  </div>
);

export default PageIntro;
